export default "__VITE_ASSET__CHoXlABX__"